import { ChannelType } from '@polyai/stream/store/reducers/channels/types';
import {
  VOICE_GREETING_REFERENCE_KEY,
  WEB_CHAT_GREETING_REFERENCE_KEY,
} from '@polyai/stream/store/utils/reference-helpers';

export { variablesReferencesAdapter } from '@polyai/schemas';

const getChannelGreetingReferenceKey = (channelType: ChannelType): string => {
  if (channelType === ChannelType.VOICE) {
    return VOICE_GREETING_REFERENCE_KEY;
  }
  if (channelType === ChannelType.WEB_CHAT) {
    return WEB_CHAT_GREETING_REFERENCE_KEY;
  }
  throw new Error(`Unknown channel type: ${channelType}`);
};

export { getChannelGreetingReferenceKey };
